import { createSelector } from 'reselect'
import { currentUserSelector } from 'selectors/currentUser'

export const getIsLoaded = (state, props) => {
  return state.kanbo.notifications.isLoaded
}

export const getIsLoading = (state, props) => {
  return state.kanbo.notifications.isLoading
}

export const getLastLoadedId = (state, props) => {
  return state.kanbo.notifications.lastLoadedId
}

export const getNotifications = (state, props) => {
  return state.kanbo.notifications.notifications
}

export const getNotificationsById = (state, props) => {
  return state.kanbo.notifications.notificationsById
}

export const notificationsSelector = createSelector(
  [getNotifications, getNotificationsById],
  (notifications, notificationsById) => {
    return notifications.map(id => notificationsById[id]).filter(notification => !notification.wasRead)
  }
)

export const getUnreadOnly = (state, props) => {
  return state.kanbo.notifications.unreadOnly
}

export const filteredNotificationsSelector = createSelector(
  [notificationsSelector],
  (notifications) => {
    return notifications.filter(notification => true || (notification.tags && notification.tags.indexOf('important') !== -1))
  }
)

export const getUnreadNotificationCount = (state, props) => {
  return state.kanbo.notifications.unreadCount
}

export default createSelector(
  [
    getIsLoaded,
    getIsLoading,
    getLastLoadedId,
    currentUserSelector,
    filteredNotificationsSelector,
    getUnreadOnly,
    getUnreadNotificationCount
  ],
  (
    isLoaded,
    isLoading,
    lastLoadedId,
    currentUser,
    notifications,
    unreadOnly,
    unreadNotificationCount
  ) => ({
    isLoaded,
    isLoading,
    lastLoadedId,
    currentUser,
    activities: notifications,
    unreadOnly,
    unreadNotificationCount
  })
)
